export const CART_SKIP_CROSS_DEVICE_MERGE_ONCE_KEY =
  'qualidoc_cart_skip_cross_device_merge_once';

export const CART_SYNC_DEBOUNCE_MS = 400;
export const CART_SYNC_BACKOFF_BASE_MS = 2000;
export const CART_SYNC_BACKOFF_MAX_MS = 120000;
